interface IGetRowCount {
  chartRows: any[] | null;
  variation: string;
}
export const getRowCount = ({
  chartRows,
  variation,
}: IGetRowCount): number | null => {
  if (!chartRows) return null;

  function countTerritories(acc: number, chart: any): number {
    return acc + chart.territoryData.length;
  }

  if (variation === 'currentPosition') {
    return chartRows.reduce(countTerritories, 0);
  }

  return chartRows.length;
};
